'use client'

import React, { ReactNode, useEffect, useRef } from 'react'

export function Tooltip(props: { text: string, icon: ReactNode }) {
  const wrapperRef = useRef<HTMLSpanElement | null>(null)
  const ref = useRef<HTMLSpanElement | null>(null)

  useEffect(() => {
    function setOrientation() {
      if (wrapperRef.current && ref.current) {
        if (window.innerWidth - wrapperRef.current.getBoundingClientRect().right < 48 * 4) {
          ref.current.style.left = 'auto'
          ref.current.style.right = '0'
        } else {
          ref.current.style.left = '0'
          ref.current.style.right = 'auto'
        }
      }
    }

    setOrientation()

    window.addEventListener('resize', setOrientation)

    return () => window.removeEventListener('resize', setOrientation)
  }, [])

  return <span className='has-tooltip relative inline w-2'>
    <span ref={wrapperRef}>{props.icon}</span>
    <span
      ref={ref}
      className='tooltip border-box z-50 rounded bg-white p-2 text-stone-400 shadow-md selection:absolute w-48'>
              {props.text}
            </span>
          </span>
}